﻿import m from "mithril";
import Requester from "../../../shared/request";
import Gateway from "../../../shared/app_settings";
import i18n from "../../../shared/i18n/i18n";
import Toasts from "../../../shared/toasts";
import ModalManager from "../../../shared/modal";
import Modal_Confirm_Delete from "../../../shared/components/modal_confirm_delete";
import Auth from "../../../shared/auth";
import UnitSettingsUtilities from "../unit_settings_utilities";
import Modal_Unit_File_History from "../modal_unit_file_history";
import FormUtilities from '../../../shared/utilities/form_utilities';
import RouterService from "../../../shared/services/router.service";

let loading, saving, uploading, deleting, unit;

function saveUnitDetails() {
    if (!FormUtilities.validateFields(".details input")) {
        return;
    }

    saving = true;
    Requester.post(Gateway.admin + "units/download/" + unit.id, {
        id: unit.id,
        name: unit.name,
        description: unit.description
    })
        .then(function (result) {
            Toasts.add("success", i18n.t("saved_changes"));
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .then(function () {
            saving = false;
        });
}

function uploadFileForDownloadUnit() {
    let d = new FormData();
    if (document.getElementById("upload-file-input").files[0] !== null) {
        let file = document.getElementById("upload-file-input").files[0];
        d.append("file", file, file.name);

        saving = false;
        uploading = true;

        Requester.upload(Gateway.admin + "units/download/" + unit.id + "/upload-file", d)
            .then(function () {
                Toasts.add("success", i18n.t("saved_changes"), "");
                unit.fileName = file.name;
            })
            .catch(function (error) {
                Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
            })
            .finally(function () {
                uploading = false;
            });
    } else {
        Toasts.add("error", i18n.t("cant_upload"), error);
        uploading = false;
    }
}

function showHistory() {
    loading = true;
    Requester.get(Gateway.admin + "units/download/" + unit.id + "/history")
        .then(function (result) {
            if (result && result.length > 0)
                ModalManager.open("History", ["modal-wide"], Modal_Unit_File_History, {history: result});
            else
                Toasts.add("warn", "No history records found");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            loading = false;
        });
}

function confirmDeleteUnit() {
    ModalManager.open("Delete Unit", [], Modal_Confirm_Delete, {callback: deleteUnit});
}

function deleteUnit() {
    deleting = true;
    Requester.delete(Gateway.admin + "units/download/" + unit.id)
        .then(function () {
            RouterService.navigateToUnits();
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            deleting = false;
        });
}

const Component_Unit_Download_Settings = {

    oninit: function (vnode) {
        unit = vnode.attrs.unit;
    },
    view: function () {
        return [
            m(".content-box", [
                m("h3", "Details"),
                m(".form .details", {class: !Auth.validateRights(["unit_download_edit"]) ? "disabled" : ""}, [
                    m(".form-section required", [
                        m(".form-label", i18n.t("name")),
                        m("input[type=text]", {
                            oninput: function () {
                                unit.name = this.value;
                            }, value: unit.name
                        })
                    ]),
                    m(".form-section", [
                        m(".form-label", i18n.t("description")),
                        m("textarea", {
                            oninput: function () {
                                unit.description = this.value;
                            }, value: unit.description
                        })
                    ]),
                    m(".form-buttons", [
                        !saving && !uploading ? m("button", {onclick: saveUnitDetails}, i18n.t("save")) : m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")])
                    ])
                ])
            ]),
            m(".content-box", [
                m("h3", "Content"),
                m(".form", [
                    m(".form-section", [
                        m(".flex-horizontal-content mb-1", {class: !Auth.validateRights(["unit_download_view"]) ? "disabled" : ""}, unit.fileName ? [
                            "Current file: " + unit.fileName, " ", m("button.btn-text", {
                                onclick: showHistory,
                                class: loading ? "disabled loading-dots" : ""
                            }, "History")
                        ] : ""),
                        m("", {class: !Auth.validateRights(["unit_download_edit"]) ? "disabled" : ""}, [
                            m(".form-label inline-tip", {"data-tip": "10MB max"}, "File"),
                            m("input[type=file].form-input#upload-file-input"),
                            uploading ? [
                                m(".loading-bar mt-1", m(".loading-width"))
                            ] : ""
                        ])
                    ]),
                    m(".form-buttons", {class: !Auth.validateRights(["unit_download_edit"]) ? "disabled" : ""}, [
                        !saving && !uploading ? m("button", {onclick: uploadFileForDownloadUnit}, i18n.t("upload")) : m("button.btn-text no-click", [i18n.t("uploading"), m(".loading-dots")])
                    ])
                ])
            ]),
            m(".content-box", [
                m(".form", {class: !Auth.validateRights(["unit_download_edit"]) ? "disabled" : ""}, [
                    m(".flex-row justify-between", [
                        m("h3.mb-0", i18n.t("active")),
                        m(".btn btn-toggle", {
                            onclick: function () {
                                UnitSettingsUtilities.toggleActiveStatus([unit.id], !unit.isActive, saving);
                                unit.isActive = !unit.isActive;
                            },
                            class: unit.isActive ? "active" : ""
                        })
                    ])
                ])
            ]),
            Auth.validateRights(["unit_download_delete"], [
                m(".content-box", [
                    !deleting ? m("button.btn-error", {onclick: confirmDeleteUnit}, "Delete Unit") : m("button.btn-text no-click text-error", ["Deleting", m(".loading-dots")])
                ])
            ])
        ];
    }
}
export default Component_Unit_Download_Settings;
